"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var clearfix = (0, _styledComponents.css)(["&:after{clear:both;content:\"\";display:table;}"]);
var _default = exports.default = clearfix;